<template>
  <div style="padding:8px">
    <div style="text-align:left" id="printMeBro">
      <h4>Healthcare Provider Information</h4>
      <v-divider></v-divider>
      <v-layout row wrap class="ml-1 pr-1">
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Name (Last, First MI)</span
          >
          <br />
          {{ app.HealthCareProvider.LastName }},
          {{ app.HealthCareProvider.FirstName }}
          {{ app.HealthCareProvider.MiddleName }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Date of Birth</span
          >
          <br />
          {{ app.HealthCareProvider.DateOfBirth | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >U.S. Citizen</span
          >
          <br />
          {{ toYesNo(app.HealthCareProvider.Citizen) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Residential Address</span
          >
          <br />
          {{ app.HealthCareProvider.Address.RAddressLine1 }} <br />
          <template v-if="app.HealthCareProvider.Address.RAddressLine2">
            {{ app.HealthCareProvider.Address.RAddressLine2 }} <br />
          </template>
          {{ app.HealthCareProvider.Address.RCity }},
          {{ app.HealthCareProvider.Address.RCounty }},
          {{ app.HealthCareProvider.Address.RState }},
          {{ app.HealthCareProvider.Address.RZip }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Mailing Address</span
          >
          <br />
          {{ app.HealthCareProvider.Address.MAddress1 }} <br />
          <template v-if="app.HealthCareProvider.Address.MAddressLine2">
            {{ app.HealthCareProvider.Address.MAddressLine2 }} <br />
          </template>
          {{ app.HealthCareProvider.Address.MCity }},
          {{ app.HealthCareProvider.Address.MCounty }},
          {{ app.HealthCareProvider.Address.MState }},
          {{ app.HealthCareProvider.Address.MZip }}
        </v-flex>
        <v-flex xs4></v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Home Phone</span
          >
          <br />
          {{ app.HealthCareProvider.HomePhone }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Work Phone</span
          >
          <br />
          {{ app.HealthCareProvider.WorkPhone }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Cell Phone</span
          >
          <br />
          {{ app.HealthCareProvider.CellPhone }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Personal Email</span
          >
          <br />
          {{ app.HealthCareProvider.PersonalEmail }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Work Email</span
          >
          <br />
          {{ app.HealthCareProvider.WorkEmail }}
        </v-flex>
        <v-flex xs4> </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Health Profession</span
          >
          <br />
          {{ app.HealthCareProvider.ProfessionAndSpecialty.HealthProfession }} -
          {{ app.HealthCareProvider.ProfessionAndSpecialty.Speciality }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Race</span>
          <br />
          {{ app.HealthCareProvider.RaceEthinicity.Race }} ({{
            app.HealthCareProvider.RaceEthinicity.Ethinicity
          }})
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Sex</span>
          <br />
          {{ app.HealthCareProvider.Gender.Sex || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Fluent in languages other than English</span
          >
          <br />
          {{ toYesNo(app.AreYouFluentInEnglish) }}
          {{ app.IfYesFluentEnglish || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Has experience in multicultural settings or special needs
            populations</span
          >
          <br />
          {{ toYesNo(app.ExperienceOrTrainiginMultiCultural) }}
          {{ app.IfYesExperienceorTRaining || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Is native of a rural or medically underserved area, or has spent
            significant time living or working in one</span
          >
          <br />
          {{ toYesNo(app.AreyouNativeOfRuralORMediUnderserveredArea) }}
          {{ app.IfYesUnderArea || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Provides substanct use disorder (SUD) treatment services</span
          >
          <br />
          {{ toYesNo(app.DoproviderSubusedisordertreatment) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Has SUD license or certificate</span
          >
          <br />
          {{ toYesNo(app.DoyouhaveSUDlicenseorcertificate) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Has DATA2000 Waiver</span
          >
          <br />
          {{ toYesNo(app.DoyouhaveaDATA2000Waiver) }}
          {{ app.IfYesDoyouhaveaDATA2000Waiver || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Is a Telehealth Provider</span
          >
          <br />
          {{ toYesNo(app.AreyouatelehealthProvider) }} <br />
          {{ app.IfYesAreyouatelehealthProvider }}
        </v-flex>
      </v-layout>
      <br />
      <h4>Licensure Information</h4>
      <v-divider></v-divider>
      <v-layout row wrap class="ml-1 pr-1">
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >License Type</span
          >
          <br />
          {{ app.Licensure.LicenseType || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >License Number</span
          >
          <br />
          {{ app.Licensure.LicenseNumber || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Discipline/Speciality</span
          >
          <br />
          {{ app.Licensure.DisciplineOrSpecialty || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Original License Date</span
          >
          <br />
          {{ app.Licensure.OriginalLicenseDate | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >License Expiration Date</span
          >
          <br />
          {{ app.Licensure.LicenseExpirationDate | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Restrictions</span
          >
          <br />
          {{ app.Licensure.Restrictions || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Licensing Agency or Board</span
          >
          <br />
          {{ app.Licensure.LicensingAgencyOfBoard || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Currently Licensed in Wyoming</span
          >
          <br />
          {{ toYesNo(app.Licensure.AreyouCurrentlyLicensedinWy) }}
          {{ app.Licensure.IfNoCurrentlyLicensedWhenWYLicensureObtained }}
        </v-flex>
      </v-layout>
      <br />
      <h4>Degree Information</h4>
      <v-divider></v-divider>
      <v-layout
        row
        wrap
        class="ml-1 pr-1"
        v-for="e in app.Education"
        :key="e.Id"
      >
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >School Type</span
          >
          <br />
          {{ e.SchoolType || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >School Name</span
          >
          <br />
          {{ e.SchoolName || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Degree</span>
          <br />
          {{ e.Degree || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Date</span>
          <br />
          {{ e.Date | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">City</span>
          <br />
          {{ e.City || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">State</span>
          <br />
          {{ e.State || '' }}
        </v-flex>
      </v-layout>
      <br />
      <h4>Apprenticeship Information</h4>
      <v-divider></v-divider>
      <v-layout
        row
        wrap
        class="ml-1 pr-1"
        v-for="a in app.Apprenticeship"
        :key="a.ID"
      >
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Site Type</span
          >
          <br />
          {{ a.ApprenticeshipSiteType || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Site Name</span
          >
          <br />
          {{ a.ApprenticeshipSiteName || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Start Date</span
          >
          <br />
          {{ a.DateFrom | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >End Date</span
          >
          <br />
          {{ a.DateTo | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">City</span>
          <br />
          {{ a.City }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">State</span>
          <br />
          {{ a.State }}
        </v-flex>
      </v-layout>
      <br />
      <h4>General Questions</h4>
      <v-divider></v-divider>
      <v-layout row wrap class="ml-1 pr-1">
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Has your license ever been suspended or revoked</span
          >
          <br />
          {{ toYesNo(app.GeneralQuestion.HaveLicenseEverBeenSuspendedRevoked) }}
          {{ app.GeneralQuestion.IfYesExplainLicenseSuspendedOrRevoked || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Are there any professional disciplinary actions pending against
            you</span
          >
          <br />
          {{
            toYesNo(app.GeneralQuestion.ProfessionalDispendPendingAgainstYou)
          }}
          {{
            app.GeneralQuestion.IfYesProfessionalDispendPendingAgainstYou || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Are there any restrictions on your license</span
          >
          <br />
          {{ toYesNo(app.GeneralQuestion.AnyRestrictionsOnYourLicense) }}
          {{
            app.GeneralQuestion.IfyesExplainAnyRestrictionsOnYourLicense || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Have you ever been convicted of or pled guilty to a felony as
            defined under federal or state law</span
          >
          <br />
          {{
            toYesNo(
              app.GeneralQuestion.HaveYourConvictedoforPledguiltyUnderFederalLaw
            )
          }}
          {{
            app.GeneralQuestion
              .IfYesHaveYourConvictedoforPledguiltyUnderFederalLaw || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Existing service obligation that will not be completed by the
            beginning of your WY-SLRP service obligation period</span
          >
          <br />
          {{ toYesNo(app.GeneralQuestion.ObligationNotCompletedWYSLRPService) }}
          {{
            app.GeneralQuestion.IfYesObligationNotCompletedWYSLRPService || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Are you in default on any educational loans</span
          >
          <br />
          {{ toYesNo(app.GeneralQuestion.DefaultAnyEducationalLoans) }}
          {{ app.GeneralQuestion.IfYesDefaultAnyEducationalLoans || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Have you ever had a judgment lien against your property for a debt
            to the United States</span
          >
          <br />
          {{
            toYesNo(app.GeneralQuestion.JudgmentLienAgainstPropertyForDebtToUS)
          }}
          {{
            app.GeneralQuestion.IfYesJudgmentLienAgainstPropertyForDebtToUS ||
              ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Have you ever defaulted on any federal payment obligations</span
          >
          <br />
          {{ toYesNo(app.GeneralQuestion.DefaultFederalPayObligations) }}
          {{ app.GeneralQuestion.IfYesDefaultFederalPayObligations || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Have you ever breached a prior service obligation to the
            federal/state/local government or other entity, even if you have
            subsequently satisfied the obligation</span
          >
          <br />
          {{
            toYesNo(
              app.GeneralQuestion.ReachedPriorServiceObligationToGovOrEntity
            )
          }}
          {{
            app.GeneralQuestion
              .IfYesReachedPriorServiceObligationToGovOrEntity || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Have you ever had any federal debt written off as uncollectible or
            had any federal service or payment obligation waived</span
          >
          <br />
          {{
            toYesNo(app.GeneralQuestion.FederalDebtWrittenOffAsUncollectible)
          }}
          {{ app.GeneralQuestion.IfFederalDebtWrittenOffAsUncollectible || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Do you have any unfulfilled child support obligations</span
          >
          <br />
          {{
            toYesNo(app.GeneralQuestion.DoYouUnfulfilledChildSupportObligations)
          }}
          {{
            app.GeneralQuestion
              .IfYesNameOfchildAddressPhoneNumberAdditionalNotes || ''
          }}
        </v-flex>
      </v-layout>
      <br />
      <h4>Loan and Lender Information</h4>
      <v-divider></v-divider>
      <v-layout
        row
        wrap
        class="ml-1 pr-1"
        v-for="l in app.LenderLoanInfo"
        :key="l.ID"
      >
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Lending Institution Name</span
          >
          <br />
          {{ l.LendingInstitutionName || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Current Loan Balance</span
          >
          <br />
          {{ l.CurrentLoanPAndIBalance || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Current Loan Balance as of</span
          >
          <br />
          {{ l.CurrentLoanAsOfdate | formattedDate }}
        </v-flex>
        <v-flex xs12>
          <strong style="color: #616161">Lender Basic Information</strong>
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Address</span>
          <br />
          {{ l.Address || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">City</span>
          <br />
          {{ l.City || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">State</span>
          <br />
          {{ l.State || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Zip</span>
          <br />
          {{ l.Zip || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Phone</span>
          <br />
          {{ l.Phone || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Fax</span>
          <br />
          {{ l.Fax || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Email</span>
          <br />
          {{ l.Email || '' }}
        </v-flex>
        <v-flex xs12>
          <strong style="color: #616161">Loan Information</strong>
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Original Loan Balance</span
          >
          <br />
          {{ l.OriginalLoanAmount || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Original Loan Date</span
          >
          <br />
          {{ l.OriginalDateOfLoan | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Interest Rate</span
          >
          <br />
          {{ l.InterestRate || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Academic Period Covered By Loan</span
          >
          <br />
          {{ l.AcademicPeriodCoveredByLoan || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Loan Type</span
          >
          <br />
          {{ l.LoanType || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Loan Account Number</span
          >
          <br />
          {{ l.LoanAccountNumber || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Is this a consolidated loan</span
          >
          <br />
          {{ toYesNo(l.IsThisaConsolidatedLoan) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Purposer of Loan Indicated on Application</span
          >
          <br />
          {{ l.PurposerOfLoanIndicatedOnApplication || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Was the loan sold</span
          >
          <br />
          {{ toYesNo(l.WasTheLoanSold) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Is the loan in default</span
          >
          <br />
          {{ toYesNo(l.IstheLoaninDefault) }}
          {{ l.IfYesDateOfLoanDefault | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Is the loan under a federal court judgment</span
          >
          <br />
          {{ toYesNo(l.IstheLoanUnderFederalCourtJudgement) }}
          {{ l.IfYesDateOfJudgement | formattedDate }}
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap class='ml-1 pr-1'>
      <v-flex xs12>
        <span class='info v-label v-label--active theme--light'>Total Eligible Debt Seeking Assistance Through WySLRP</span> <br/>

      </v-flex>
    </v-layout> -->
      <br />
      <h4>Practice Site Information</h4>
      <v-divider></v-divider>
      <v-layout
        row
        wrap
        class="ml-1 pr-1"
        v-for="p in app.PracticeSiteInformation"
        :key="p.ID"
      >
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Name</span>
          <br />
          {{ p.SiteAddress.SiteInsitutionName || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Medical Director</span
          >
          <br />
          {{ p.MedicalDirectorName || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Site Contact</span
          >
          <br />
          {{ p.SiteContactNameTitle || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Address</span>
          <br />
          {{ p.SiteAddress.Address1 || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">City</span>
          <br />
          {{ p.SiteAddress.City || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">State</span>
          <br />
          {{ p.SiteAddress.State || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Zip</span>
          <br />
          {{ p.SiteAddress.Zip || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">County</span>
          <br />
          {{ p.SiteAddress.County || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Phone</span>
          <br />
          {{ p.Phone || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">Email</span>
          <br />
          {{ p.Email || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Employment Date</span
          >
          <br />
          {{ p.EmploymentDate | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Hours per Week Worked</span
          >
          <br />
          {{ p.HoursWorkedAtthisSite || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">HPSA ID</span>
          <br />
          {{ p.HPSADesignationID || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >HPSA Score</span
          >
          <br />
          {{ p.HPSAScore || '' }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Designation Type</span
          >
          <br />
          Geographic: {{ toYesNo(p.DesignationTypeGeographic) }} Low-Income:
          {{ toYesNo(p.DesignationTypeLowIncome) }} Facility:
          {{ toYesNo(p.DesignationTypeFacility) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >HPSA Type</span
          >
          <br />
          Primary Care: {{ toYesNo(p.HPSATypePrimaryCare) }} Dental:
          {{ toYesNo(p.HPSATypeDental) }} MentalHealth:
          {{ toYesNo(p.HPSATypeMentalHealth) }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >Is an approved National Health Service Corps site</span
          >
          <br />
          {{ toYesNo(p.IsthisAdditionLocationApprovedNationalHealthSCSite) }}
        </v-flex>
      </v-layout>
      <v-layout row wrap class="ml-1 pr-1">
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light"
            >If not currently employed, date emplyment will begin</span
          >
          <br />
          {{ app.PracticeSite.IfNotCurrentlyEmployedStartDate | formattedDate }}
        </v-flex>
        <v-flex xs4>
          <span class="info v-label v-label--active theme--light">FEIN</span>
          <br />
          {{ app.PracticeSite.FEIN || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Does the practice site accept all patients regardless of insurance
            or ability to pay</span
          >
          <br />
          {{
            toYesNo(
              app.PracticeSite
                .DoesitAcceptAllPatientsRegardInsuranceorAbilitytoPay
            )
          }}
          {{ app.PracticeSite.IfNoDetailedInformation || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Public Entity</span
          >
          <br />
          {{ toYesNo(app.PracticeSite.PublicEntity) }}
          {{ app.PracticeSite.IfYesTypeOfPracticePublicEntity || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Private not-for-Profit</span
          >
          <br />
          {{ toYesNo(app.PrivateNotforProfit) }}
          {{ app.PracticeSite.IfYesTypeOfPracticePrivateNonProfit || '' }}
        </v-flex>
        <v-flex xs6></v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >National Health Service Corps Site Approval Date</span
          >
          <br />
          {{ app.PracticeSite.NationalHSCorpsSiteApprovalDate | formattedDate }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Expiration</span
          >
          <br />
          {{ app.PracticeSite.NHSAExpiration | formattedDate }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Are there any limits on patients the healthcare provider or
            practice site accepts</span
          >
          <br />
          {{ toYesNo(app.PracticeSite.AnyLimitToPatinetsSiteAccepts) }}
          {{ app.PracticeSite.IfYesExplainSiteAccepts || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Does the healthcare provider and the practice site accept Medicare
            assignment</span
          >
          <br />
          {{ toYesNo(app.PracticeSite.DoesAcceptMedicareAssignment) }}
          {{ app.PracticeSite.IfYesExplainMedicareAssignment || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Does the healthcare provider and the practice site accept
            Medicaid/KidCare CHIP patients</span
          >
          <br />
          {{
            toYesNo(app.PracticeSite.DoesHCPSiteAcceptsMedicacisKidChipPatients)
          }}
          {{
            app.PracticeSite
              .IfNoHCPSiteAcceptsMedicacisKidChipPatientsDetails || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Practice Site Boundaries</span
          >
          <br />
          {{ app.PracticeSite.ListPracticeSiteBoundaries || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Population Centers Included in this Practice Site</span
          >
          <br />
          {{ app.PracticeSite.PopulationCentersIncludeinPracticeArea || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Indicators of unusually high need in the service area</span
          >
          <br />
          {{ app.PracticeSite.ListAnyIndicatorsOfUnusuallyHighNeeds || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Total number of full-time equivalent (FTE) providers employed by
            the practice site in the applicant’s healthcare discipline</span
          >
          <br />
          {{
            app.PracticeSite.TotalNoOfFullTimeEquEmployedinthePracticeSite || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Total number of active patients at the practice site</span
          >
          <br />
          {{ app.PracticeSite.TotalNumberOfActivePatients || '' }}
        </v-flex>
      </v-layout>
      <br />
      <h4>Employment Form</h4>
      <v-divider></v-divider>
      <v-layout v-if="app.Employment" row wrap class="ml-1 pr-1">
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Recruitment</span
          >
          <br />
          {{ toYesNo(app.Employment.RecruitmentwithinLastThreeMonths) }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Retention</span
          >
          <br />
          {{ toYesNo(app.Employment.RetentionExistingStaff) }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Weekly days and hours worked</span
          >
          <br />
          {{ app.Employment.WeeklyDaysAndHoursWorkedatPracticeLocation || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Does the healthcare professional provide services at multiple
            locations</span
          >
          <br />
          {{ toYesNo(app.Employment.HCProvideServiceatMultipleLocation) }}
          {{ app.Employment.IfYesExplainAdditionalPracticeSites || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Does the healthcare professional provide specialty care/services at
            the practice site</span
          >
          <br />
          {{ toYesNo(app.Employment.HCProvideSpecialCareAtPracticeSite) }}
          {{ app.Employment.IfYesHCProvideSpeacialCareAtSite || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >List the proposed/current salary for the healthcare
            professional</span
          >
          <br />
          {{
            app.Employment.ProposedSalary.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            }) || ''
          }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >List the benefits and malpractice coverage provided</span
          >
          <br />
          {{ app.Employment.BenefitsMalPracticeCoverage || '' }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Has the site, or will the site, reduce the healthcare
            professional’s compensation as a result of participation in
            WY-SLRP</span
          >
          <br />
          {{ toYesNo(app.Employment.ReduceTheCompensationAsaResultOfWYSLRP) }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Is there an agreement between the site and the healthcare
            professional for bonus payments which create a service
            obligation</span
          >
          <br />
          {{ toYesNo(app.Employment.AggrementbtSiteAndHCBonusPay) }}
        </v-flex>
        <v-flex xs6>
          <span class="info v-label v-label--active theme--light"
            >Describe the practice site’s plan to retain the healthcare
            professional in the service area upon completion of their service
            obligation to the WY-SLRP</span
          >
          <br />
          {{
            app.Employment
              .DescribetheSitePlanRetainHCServiceAreaUponCompletiontoWYSLRP ||
              ''
          }}
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    app: Object,
  },
  data() {
    return {
      dialog: false,
    }
  },
  created() {},
  computed: {},
  methods: {
    openDialog() {
      this.dialog = true
      this.$htmlToPaper('printMeBro')
    },
    toYesNo(val) {
      if (val == true) {
        return 'Yes'
      } else if (val == false) {
        return 'No'
      }
      return 'No Answer'
    },
    print() {
      var d = document.getElementsByClassName('v-dialog--active')[0].innerHTML
      let stylesHtml = ''
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML
      }
      let printWin = window.open('', 'print', 'height=800,width=1050')
      printWin.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${d}
        </body>
      </html>`)
      printWin.print()
    },
  },
  watch: {},
  components: {},
}
</script>
<style scoped>
.info {
  font-size: 12px;
}
</style>
